/* eslint-disable react-hooks/exhaustive-deps */
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridRowProps, GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSelector } from "src/stateManagement/redux";
import { ActivitiesDetails } from "./components/details";
import './styles.scss'
import moment from "moment";
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import { tableStyles } from "src/shared/util/tableStyles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { config } from "src/stateManagement/redux/configVar";

const serverUrl = config.serverUrl;

/** Las notas guardan `variables` como objeto JSON; el modal de detalles
 *  espera un arreglo de { name, value }. Normalizamos para no romperlo. */
const normalizeVariables = (variables: any): any[] => {
    if (Array.isArray(variables)) return variables;
    if (variables && typeof variables === "object") {
        return Object.entries(variables).map(([name, value]) => ({
            name,
            value: value ?? "",
        }));
    }
    return [];
};

export const TechnicalMeetDiscussions = () => {
    const { locationId } = useSelector((state) => state.location);
    const [data, setData] = useState<any>();
    const [activityType, setActivityType] = useState("");
    const [showDetails, setShowDetails] = useState(false);
    const [loading, setLoading] = useState(false);

    const [dataForTable, setDataForTable] = useState<any[]>([])

    useEffect(() => {
        if (!locationId) {
            setDataForTable([]);
            return;
        }
        let cancelled = false;
        const fetchNotes = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("authToken");
                const response = await fetch(
                    `${serverUrl}/api/location-technical-notes/by-location/${encodeURIComponent(locationId)}?noteType=technical_meeting&pageSize=200`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                    }
                );
                const json = await response.json();
                if (cancelled) return;
                setDataForTable(Array.isArray(json?.items) ? json.items : []);
            } catch {
                if (!cancelled) setDataForTable([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        fetchNotes();
        return () => {
            cancelled = true;
        };
    }, [locationId])


    const handleShowDetails = (data: any, discussedBy: any, discussedWith: string, executedDate: string) => {

        setData({
             variables: data,
             discussedBy,
             discussedWith,
             executedDate
         });
        setActivityType("Discusión Mesa Técnica");
        setShowDetails(true);
    };

    const columns: GridColDef[] = [
        {
            field: "executedDate",
            headerName: "Fecha",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "discussedBy",
            headerName: "Discutido por",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "discussedWith",
            headerName: "Discutido con",
            flex: 0.5,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "comments",
            headerName: "Comentario",
            headerAlign: "center",
            flex: 1,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            sx={{
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                lineHeight: "1.4",
                                py: "5px",
                                px: "2px",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                display: "-webkit-box",
                            }}
                        >
                            {params.row.comments}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "actions",
            headerAlign: "center",
            align: "center",
            headerName: "Opciones",
            flex: 0.2,
            renderHeader: () => (
                <IconButton onClick={() => console.log("Header action")}>
                    <MoreVertIcon />
                </IconButton>
            ),
            renderCell: (params) => {
                return (
                    <IconButton
                        size="small"
                         onClick={() =>
                            handleShowDetails(
                                params.row.variables,
                                params.row.discussedBy,
                                params.row.discussedWith,
                                params.row.executedDate
                            )
                        }
                    >
                        <MoreVertIcon />
                    </IconButton>
                );
            },
        },
    ];

    const rows: GridRowsProp = dataForTable.map((item: any) => {
        return {
            id: item.id,
            fieldActivityId: item.id,
            executedDate: moment(item.executedDate).format("DD-MM-YYYY"),
            discussedBy: item.discussedBy,
            discussedWith: item.discussedWith,
            comments: item.comments,
            variables: normalizeVariables(item.variables),
        };
    });

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <Grid container spacing={0}>
            {showDetails ? (
                <ActivitiesDetails
                    setShowDetails={setShowDetails}
                    details={data}
                    activityType={activityType}
                />
            ) : loading ? (
                <Grid size={12}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 3 }}>
                        <CircularProgress size={20} />
                        <Typography variant="caption">Cargando discusiones técnicas…</Typography>
                    </Box>
                </Grid>
            ) : (
                <Grid size={12}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                            height: {
                                md: `calc(100vh - 375px)`,
                                lg: `calc(100vh - 375px)`,
                                xl: `calc(100vh - 383px)`,
                            },
                            ...tableStyles,
                        }}
                        getRowId={(row) => row.id}
                    />
                </Grid>
            )}
        
        </Grid>
    );
};
